import styled from 'styled-components';

const Box = styled.div`
  background:
    radial-gradient(circle at 18% 20%, rgba(30, 134, 153, .22), transparent 28rem),
    linear-gradient(112deg, rgba(4, 42, 51, .98) 0%, rgba(8, 66, 79, .94) 48%, rgba(8, 66, 79, .48) 100%),
    url(${props => props.backgroundImage}) center right / cover no-repeat;
  display: flex;
  align-items: center;
  height: 100%;
  position: absolute;
  width: 100%;
  padding: clamp(24px, 8vw, 112px);

  @media (max-width: 768px) {
    padding: 15px;
    justify-content: center;
    align-items: center;
  }
`

Box.Container = styled.div`
  width: 100%;
  max-width: 440px;
`

Box.Content = styled.div`
  border-radius: 24px;
  padding: 40px;
  background: rgba(250, 253, 253, .96);
  border: 1px solid rgba(255,255,255,.72);
  box-shadow: 0 30px 80px rgba(3, 42, 51, .38);
  backdrop-filter: blur(18px);

  @media (max-width: 768px) {
    padding: 28px 22px;
  }
`

Box.Logo = styled.img`
  max-width: 180px;
  max-height: 72px;
  object-fit: contain;
`

export default Box
